import { PrecedentMapModel } from "./precedent-map";
import { AppEvents } from "../../app-events";
import { autoinject, Container } from "aurelia-dependency-injection";
import { prop } from "../../decorators/property";

@autoinject
export class PrecedentMapControlsModel extends Backbone.Model {
    public precedentMapHistory: PrecedentMapModel[];
    @prop() public ExitUrl: string;
    private prev: PrecedentMapModel;
    private current: PrecedentMapModel;

    constructor(private appEvents: Backbone.Events) {
        super();
        this.precedentMapHistory = [];
    }

    public resetHistory() {
        this.precedentMapHistory = [];
    }

    public logChange(model: PrecedentMapModel, fromHistory) {
        let existing;
        existing = _.find(this.precedentMapHistory, (item) => {
            return (item as any).get("UniqueId") === model.UniqueId;
        });

        if (existing) {
            model = existing;
        } else {
            this.precedentMapHistory.push(model);
        }

        this.current = model;
        this.updateButtons();
    }

    public setDisplayTypes(types, animate) {
        this.set("DisplayTypes", types);
        this.appEvents.trigger(AppEvents.PrecedentMapDisplayTypesChanged, { relationTypes: types, animate});
    }

    private updateButtons() {
        const idx = this.precedentMapHistory.indexOf(this.current);
        this.set("BackEnabled", idx > 0);
        this.set("ForwardEnabled", idx < (this.precedentMapHistory.length - 1));
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/precedent-map/models/precedent-map-controls.ts